import React from 'react'
import classnames from 'classnames/bind'
import { images } from '../../../../../images/exported'
import styles from '../index.scss'
import { watermarkTypes } from '../../../../../constants'

const cx = classnames.bind(styles)

const ImageWatermark = ({ type }: { type?: keyof typeof watermarkTypes }) => {
  let targetImage
  switch (type) {
    case watermarkTypes.SmartSale:
      targetImage = images.smartsaleLogoIcon
      break
    default:
      targetImage = null
  }
  if (!targetImage) {
    return null
  }
  return (
    <div className={cx('watermark-container')}>
      <img className={cx('watermark-image')} src={images.smartsaleLogoIcon} />
    </div>
  )
}

export default ImageWatermark
